import React, { useState, useEffect } from 'react';

const AddToCampaignModal = ({ onClose, onSave, executive }) => {
  const [campaigns, setCampaigns] = useState([]);
  const [selectedCampaignId, setSelectedCampaignId] = useState('');
  const [loading, setLoading] = useState(true);

  // Load campaigns from localStorage
  useEffect(() => {
    const loadCampaigns = () => {
      setLoading(true);
      const savedCampaigns = localStorage.getItem('campaigns');
      if (savedCampaigns) {
        const campaignsList = JSON.parse(savedCampaigns);
        // Only show active or planned campaigns
        const activeCampaigns = campaignsList.filter(
          c => c.status === 'active' || c.status === 'planned'
        );
        setCampaigns(activeCampaigns);
        if (activeCampaigns.length > 0) {
          setSelectedCampaignId(activeCampaigns[0].id.toString());
        }
      }
      setLoading(false);
    };

    loadCampaigns();
  }, []);

  // Handle campaign selection
  const handleCampaignChange = (e) => {
    setSelectedCampaignId(e.target.value);
  };

  // Handle save
  const handleSave = () => {
    if (!selectedCampaignId) return;
    
    const campaignId = parseInt(selectedCampaignId);
    const campaign = campaigns.find(c => c.id === campaignId);
    
    if (campaign) {
      onSave(campaign, executive);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md mx-4 overflow-hidden">
        <div className="bg-primary text-white px-6 py-4 flex justify-between items-center">
          <h3 className="text-xl font-semibold">Add to Campaign</h3>
          <button 
            onClick={onClose}
            className="text-white hover:text-gray-200"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>
        
        <div className="p-6">
          <div className="mb-6">
            <p className="text-gray-700 mb-2">
              Add <span className="font-semibold">{executive.name}</span> to a campaign:
            </p>
            
            {loading ? (
              <div className="py-4 text-center text-gray-500">
                Loading campaigns...
              </div>
            ) : campaigns.length > 0 ? (
              <div className="mt-4">
                <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="campaign">
                  Select Campaign
                </label>
                <select
                  id="campaign"
                  value={selectedCampaignId}
                  onChange={handleCampaignChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
                >
                  {campaigns.map(campaign => (
                    <option key={campaign.id} value={campaign.id}>
                      {campaign.name} ({campaign.status})
                    </option>
                  ))}
                </select>
              </div>
            ) : (
              <div className="py-4 text-center text-gray-500">
                No active campaigns available. Please create a campaign first.
              </div>
            )}
          </div>
          
          <div className="flex justify-end gap-3">
            <button
              onClick={onClose}
              className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300"
            >
              Cancel
            </button>
            <button
              onClick={handleSave}
              disabled={!selectedCampaignId || campaigns.length === 0}
              className={`px-4 py-2 rounded-md ${
                selectedCampaignId && campaigns.length > 0
                  ? 'bg-primary text-white hover:bg-blue-700'
                  : 'bg-gray-300 text-gray-500 cursor-not-allowed'
              }`}
            >
              Add to Campaign
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddToCampaignModal;
